import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

type TeaserSliderData = {}

export default ():AlpineComponent<TeaserSliderData> => ({
  init() {
    const swiperEl = this.$root.querySelector<HTMLElement>('.swiper');

    if (!swiperEl) {
      return;
    }

    new Swiper(swiperEl, {
      speed: 500,
      threshold: 10,
      spaceBetween: 50,
      slidesPerView: 3,
      watchOverflow: true,
      followFinger: true,
      updateOnWindowResize: true,
      modules: [Navigation, Pagination],
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
      navigation: {
        prevEl: this.$root.querySelector<HTMLElement>('.ce-teasers-slider-btn--prev'),
        nextEl: this.$root.querySelector<HTMLElement>('.ce-teasers-slider-btn--next'),
      },
    });
  },
});
